// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { List, Dict } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetMarkets (params?: {}): Promise<List>;
    publicGetMarketsSymbol (params?: {}): Promise<List>;
    publicGetCurrencies (params?: {}): Promise<List>;
    publicGetCurrenciesCurrency (params?: {}): Promise<Dict>;
    publicGetV2Currencies (params?: {}): Promise<List>;
    publicGetV2CurrenciesCurrency (params?: {}): Promise<Dict>;
    publicGetTimestamp (params?: {}): Promise<Dict>;
    publicGetMarketsPrice (params?: {}): Promise<List>;
    publicGetMarketsSymbolPrice (params?: {}): Promise<Dict>;
    publicGetMarketsMarkPrice (params?: {}): Promise<List>;
    publicGetMarketsSymbolMarkPrice (params?: {}): Promise<Dict>;
    publicGetMarketsSymbolMarkPriceComponents (params?: {}): Promise<Dict>;
    publicGetMarketsSymbolOrderBook (params?: {}): Promise<Dict>;
    publicGetMarketsSymbolCandles (params?: {}): Promise<List>;
    publicGetMarketsSymbolTrades (params?: {}): Promise<List>;
    publicGetMarketsTicker24h (params?: {}): Promise<List>;
    publicGetMarketsSymbolTicker24h (params?: {}): Promise<Dict>;
    publicGetMarketsCollateralInfo (params?: {}): Promise<List>;
    publicGetMarketsCurrencyCollateralInfo (params?: {}): Promise<Dict>;
    publicGetMarketsBorrowRatesInfo (params?: {}): Promise<List>;
    privateGetAccounts (params?: {}): Promise<Dict>;
    privateGetAccountsBalances (params?: {}): Promise<Dict>;
    privateGetAccountsIdBalances (params?: {}): Promise<List>;
    privateGetAccountsActivity (params?: {}): Promise<List>;
    privateGetAccountsTransfer (params?: {}): Promise<List>;
    privateGetAccountsTransferId (params?: {}): Promise<Dict>;
    privateGetFeeinfo (params?: {}): Promise<Dict>;
    privateGetAccountsInterestHistory (params?: {}): Promise<List>;
    privateGetSubaccounts (params?: {}): Promise<Dict>;
    privateGetSubaccountsBalances (params?: {}): Promise<List>;
    privateGetSubaccountsIdBalances (params?: {}): Promise<List>;
    privateGetSubaccountsTransfer (params?: {}): Promise<List>;
    privateGetSubaccountsTransferId (params?: {}): Promise<Dict>;
    privateGetWalletsAddresses (params?: {}): Promise<Dict>;
    privateGetWalletsAddressesCurrency (params?: {}): Promise<Dict>;
    privateGetWalletsActivity (params?: {}): Promise<Dict>;
    privateGetMarginAccountMargin (params?: {}): Promise<Dict>;
    privateGetMarginBorrowStatus (params?: {}): Promise<List>;
    privateGetMarginMaxSize (params?: {}): Promise<Dict>;
    privateGetOrders (params?: {}): Promise<List>;
    privateGetOrdersId (params?: {}): Promise<List>;
    privateGetOrdersKillSwitchStatus (params?: {}): Promise<Dict>;
    privateGetSmartorders (params?: {}): Promise<List>;
    privateGetSmartordersId (params?: {}): Promise<List>;
    privateGetOrdersHistory (params?: {}): Promise<Dict>;
    privateGetSmartordersHistory (params?: {}): Promise<List>;
    privateGetTrades (params?: {}): Promise<List>;
    privateGetOrdersIdTrades (params?: {}): Promise<List>;
    privatePostAccountsTransfer (params?: {}): Promise<Dict>;
    privatePostSubaccountsTransfer (params?: {}): Promise<Dict>;
    privatePostWalletsAddress (params?: {}): Promise<Dict>;
    privatePostWalletsWithdraw (params?: {}): Promise<Dict>;
    privatePostV2WalletsWithdraw (params?: {}): Promise<Dict>;
    privatePostOrders (params?: {}): Promise<Dict>;
    privatePostOrdersBatch (params?: {}): Promise<Dict>;
    privatePostOrdersKillSwitch (params?: {}): Promise<Dict>;
    privatePostSmartorders (params?: {}): Promise<Dict>;
    privateDeleteOrdersId (params?: {}): Promise<Dict>;
    privateDeleteOrdersCancelByIds (params?: {}): Promise<List>;
    privateDeleteOrders (params?: {}): Promise<List>;
    privateDeleteSmartordersId (params?: {}): Promise<Dict>;
    privateDeleteSmartordersCancelByIds (params?: {}): Promise<List>;
    privateDeleteSmartorders (params?: {}): Promise<List>;
    privatePutOrdersId (params?: {}): Promise<Dict>;
    privatePutSmartordersId (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketAllInstruments (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketInstruments (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketOrderBook (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketCandles (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketIndexPriceCandlesticks (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketPremiumIndexCandlesticks (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketMarkPriceCandlesticks (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketTrades (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketLiquidationOrder (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketTickers (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketMarkPrice (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketIndexPrice (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketIndexPriceComponents (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketFundingRate (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketFundingRateHistory (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketOpenInterest (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketInsurance (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketRiskLimit (params?: {}): Promise<Dict>;
    swapPublicGetV3MarketLimitPrice (params?: {}): Promise<Dict>;
    swapPrivateGetV3AccountBalance (params?: {}): Promise<Dict>;
    swapPrivateGetV3AccountBills (params?: {}): Promise<Dict>;
    swapPrivateGetV3TradeOrderOpens (params?: {}): Promise<Dict>;
    swapPrivateGetV3TradeOrderTrades (params?: {}): Promise<Dict>;
    swapPrivateGetV3TradeOrderHistory (params?: {}): Promise<Dict>;
    swapPrivateGetV3TradeOrderDetails (params?: {}): Promise<Dict>;
    swapPrivateGetV3TradePositionOpens (params?: {}): Promise<Dict>;
    swapPrivateGetV3TradePositionHistory (params?: {}): Promise<Dict>;
    swapPrivateGetV3PositionLeverages (params?: {}): Promise<Dict>;
    swapPrivateGetV3PositionMode (params?: {}): Promise<Dict>;
    swapPrivateGetV3PositionRiskLimit (params?: {}): Promise<Dict>;
    swapPrivatePostV3TradeOrder (params?: {}): Promise<Dict>;
    swapPrivatePostV3TradeOrders (params?: {}): Promise<Dict>;
    swapPrivatePostV3TradePosition (params?: {}): Promise<Dict>;
    swapPrivatePostV3TradePositionAll (params?: {}): Promise<Dict>;
    swapPrivatePostV3PositionLeverage (params?: {}): Promise<Dict>;
    swapPrivatePostV3PositionMode (params?: {}): Promise<Dict>;
    swapPrivatePostV3TradePositionMargin (params?: {}): Promise<Dict>;
    swapPrivateDeleteV3TradeOrder (params?: {}): Promise<Dict>;
    swapPrivateDeleteV3TradeBatchOrders (params?: {}): Promise<Dict>;
    swapPrivateDeleteV3TradeAllOrders (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
